module.exports = __webpack_public_path__ + "img/logo_black.093dd202.svg";